import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Col } from "reactstrap"

//Date Picker
import { suggestCompanies } from "helpers/blopsleads_helper"
import StatusMap from "helpers/statusMap"
import moment from "moment"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const JobListGlobalFilter = ({
  selectedFilters,
  setFilters,
  loading,
  onSearchClick,
  setStartPanel,
}) => {
  const optionGroupStatus = [
    {
      label: "Status",
      options: [
        { label: StatusMap.Novo.text, value: StatusMap.Novo.value },
        { label: StatusMap.Incompleto.text, value: StatusMap.Incompleto.value },
        {
          label: StatusMap.EmAprovação.text,
          value: StatusMap.EmAprovação.value,
        },
        { label: StatusMap.Concluido.text, value: StatusMap.Concluido.value },
        { label: StatusMap.Manual.text, value: StatusMap.Manual.value },
        { label: StatusMap.Monitorado.text, value: StatusMap.Monitorado.value },
        {
          label: StatusMap.NaoMonitorado.text,
          value: StatusMap.NaoMonitorado.value,
        },
        {
          label: StatusMap.NaoPriorizado.text,
          value: StatusMap.NaoPriorizado.value,
        },
        {
          label: StatusMap.Excluido.text,
          value: StatusMap.Excluido.value,
        },
      ],
    },
  ]

  const optionGroupPrioridade = [
    {
      label: "Prioridades",
      options: [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
        { label: "7", value: "7" },
        { label: "8", value: "8" },
        { label: "9", value: "9" },
        { label: "10", value: "10" },
        { label: "99", value: "99" },
      ],
    },
  ]

  const selectedFilter = JSON.parse(localStorage.getItem("pendingFilter"))

  const [selectedStatus, setselectedStatus] = useState([StatusMap.Novo.value])
  const [selectedPrioridade, setselectedPrioridade] = useState(["1"])
  const [selectedData, setselectedData] = useState(null)
  const [companyQuery, setCompanyQuery] = useState("")
  const [companyOptions, setCompanyOptions] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [notPrioritized, setNotPrioritized] = useState(false)

  const valueToTextMap = Object.keys(StatusMap).reduce((acc, key) => {
    acc[StatusMap[key].value] = StatusMap[key].text
    return acc
  }, {})

  // useEffect(() => {
  //   if (selectedStatus[0] === 8) {
  //     setNotPrioritized(true)
  //     setselectedPrioridade(["99"])
  //     setFilters({
  //       Status: [StatusMap.NaoPriorizado.value],
  //       Prioridade: ["99"],
  //       Data: "todasdatas",
  //     })
  //   } else {
  //     setNotPrioritized(false)
  //     setselectedPrioridade(selectedFilters.Prioridade || [])
  //   }
  // }, [selectedStatus])
  function handleStatus(status) {
    setselectedStatus(status.map(d => d.value))
  }

  function getDefaultValues(selectedStatus) {
    return selectedStatus.map(item => {
      if (typeof item === "number") {
        return { label: valueToTextMap[item], value: item }
      }
      return item
    })
  }

  function handlePrioridade(prioridade) {
    setselectedPrioridade(prioridade.map(d => d.value))
  }

  function handleData(data) {
    setselectedData(data ? moment(data).format("YYYY-MM-DD") : null)
  }

  // auto-complete companies (debounced)
  useEffect(() => {
    const controller = new AbortController()
    const handle = setTimeout(async () => {
      try {
        if (companyQuery && companyQuery.length >= 2) {
          const list = await suggestCompanies(companyQuery)
          const unique = Array.from(new Set(list || []))
          setCompanyOptions(unique.map(name => ({ label: name, value: name })))
        } else {
          setCompanyOptions([])
        }
      } catch (e) {
        setCompanyOptions([])
      }
    }, 400)
    return () => {
      clearTimeout(handle)
      controller.abort()
    }
  }, [companyQuery])

  return (
    <React.Fragment>
      <Col xxl={4} lg={4}>
        <div className="mb-3">
          <label className="control-label">Status</label>
          <Select
            defaultValue={getDefaultValues(selectedFilters.Status)}
            isMulti={true}
            onChange={e => {
              handleStatus(e || undefined)
            }}
            options={optionGroupStatus}
            menuPortalTarget={document.body}
            className="select2-selection"
          />
        </div>
      </Col>
      <Col xxl={4} lg={3}>
        <div className="mb-3">
          <label className="control-label">Prioridade</label>
          <Select
            defaultValue={selectedFilters.Prioridade.map(item => ({
              label: item,
              value: item,
            }))}
            isMulti={true}
            onChange={e => {
              handlePrioridade(e || undefined)
            }}
            options={optionGroupPrioridade}
            menuPortalTarget={document.body}
            className="select2-selection"
          />
        </div>
      </Col>
      <Col xxl={2} lg={3}>
        <div className="mb-3">
          <label className="control-label">Data Disponibilização</label>
          <DatePicker
            className="form-control mb-3 mb-xxl-0"
            name="filtroData"
            selected={selectedData ? moment(selectedData).toDate() : null}
            value={
              selectedData ? moment(selectedData).format("DD/MM/YYYY") : null
            }
            onChange={handleData}
            onBlur={handleData}
          />
        </div>
      </Col>
      <Col xxl={4} lg={3}>
        <div className="mb-3">
          <label className="control-label">Empresa</label>
          <Select
            placeholder="Digite para buscar empresa..."
            options={companyOptions}
            value={selectedCompany}
            onInputChange={val => setCompanyQuery(val)}
            onChange={opt => setSelectedCompany(opt)}
            onBlur={() => setCompanyQuery("")}
            isClearable
            menuPortalTarget={document.body}
            className="select2-selection"
          />
        </div>
      </Col>
       {/* <Col xxl={4} lg={3}>
        <div className="mb-3">
          <label className="control-label">Empresa</label>
          <Select
            defaultValue={selectedFilters.Prioridade.map(item => ({
              label: item,
              value: item,
            }))}
            isMulti={true}
            onChange={e => {
              handlePrioridade(e || undefined)
            }}
            options={optionGroupPrioridade}
            menuPortalTarget={document.body}
            className="select2-selection"
          />
        </div>
      </Col> */}
      {/* <Col xxl={2} lg={2}>
        <div className="mb-3 mb-xxl-0 vertical-center">
          <button
            type="button"
            className="btn btn-soft-secondary w-100"
            onClick={() => {
              setLoading(true)
              onSearchClick({
                Status:
                  selectedStatus.length > 0
                    ? selectedStatus.map(d => d.value)
                    : "todosstatus",
                Prioridade:
                  selectedPrioridade.length > 0
                    ? selectedPrioridade.map(d => d.value)
                    : "todasprioridades",
                Data: selectedData !== null ? selectedData : "todasdatas",
              })
            }}
          >
            <i className="mdi mdi-filter-outline align-middle"></i>
            Buscar
          </button>
        </div>
      </Col> */}

      <Col xxl={2} lg={2}>
        <div className="mb-3 mb-xxl-0 vertical-center">
          <button
            type="button"
            className="btn btn-soft-secondary w-100"
            onClick={() => {
              setStartPanel(false)
              onSearchClick({
                Status:
                  selectedStatus.length > 0
                    ? selectedStatus.map(d => d)
                    : "todosstatus",
                Prioridade:
                  selectedPrioridade.length > 0
                    ? selectedPrioridade.map(d => d)
                    : "todasprioridades",
                Data: selectedData !== null ? selectedData : "todasdatas",
                Empresa: selectedCompany?.value || null,
              })
            }}
            disabled={loading}
          >
            <i
              className={
                loading
                  ? "bx bx-loader bx-spin align-middle me-2"
                  : "mdi mdi-filter-outline align-middle"
              }
            ></i>
            {loading ? "Carregando..." : "Buscar"}
          </button>
        </div>
      </Col>
    </React.Fragment>
  )
}
export default JobListGlobalFilter
